import { useUserEvents } from '@xylabs/react-pixel'

import { UserEvents } from './UserEvents'

export const useCoinUserEvents = () => {
  return useUserEvents() as UserEvents<Record<string, unknown>>
}
